import React      from 'react';
import Dropzone   from 'react-dropzone';
import Spinner    from 'react-spinner';
import ImageForm  from './image_form';

export default class MultiImageForm extends React.Component {
  constructor(props) {
    super(props);
    this.url = this.props.url;
    this.state = {
      imageForms: (this.props.imageForms || []),
      loadingCount: 0
    };
    this.loadingCount = 0;
  }

  onDrop = (files) => {
    files.forEach(function (attachment) {
      this.postAttachment(attachment);
      this.setState((prevState) => {
        return { loadingCount: (prevState.loadingCount + 1) };
      });
    }.bind(this));
  }

  postAttachment(attachment) {
    var data = new FormData();
    data.append('attachment', attachment)

    $.ajax({
      type: "POST",
      url: this.url,
      data: data,
      cache: false,
      dataType: 'json',
      processData: false,
      contentType: false,
      success: function(data) {
        this.setState((prevState) => {
          var newImageForms = prevState.imageForms
          var newImageForm = {
            preview: data.attachment_url,
            url: data.update_url
          }
          newImageForms.push(newImageForm)

          return {
            imageForms: newImageForms,
            loadingCount: (prevState.loadingCount - 1)
          };
        });
      }.bind(this)
    });
  }

  spinner() {
    if (this.state.loadingCount == 0) return;
    return (
      <Spinner style={{ position: 'absolute' }} />
    );
  }

  afterDelete(index) {
    this.setState((prevState) => {
      prevState.imageForms.splice(index, 1)
      return { imageForms: prevState.imageForms };
    });
  }

  imageForms() {
    return (
      this.state.imageForms.map((e, index) =>
        <div className={this.props.colClass} key={e.url}>
          <ImageForm preview={e.preview}
                     url={e.url}
                     afterDelete={this.afterDelete.bind(this, index)} />
        </div>
      )
    );
  }

  render() {
    var dropzoneRef;

    return (
      <div className={this.props.rowClass + ' multi-image-form'}>
        {this.imageForms()}
        <div className={this.props.colClass}>
          <div className='image-form'>
            <Dropzone multiple={true}
                      accept='image/*'
                      onDrop={this.onDrop}
                      className='thumbnail'
                      style={{ marginBottom: 0, height: '140px' }}
                      ref={(node) => { dropzoneRef = node }}>
              {this.spinner()}
              <img className='img-responsive'
                   src="/original/attachment_missing.svg"/>
            </Dropzone>

            <div className="dropdown">
              <a className='btn btn-warning btn-sm'
                 onClick={() => { dropzoneRef.open() }}>
                <i className="icon-pencil icon"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./app/javascript/components/multi_image_form.jsx